class MySelectDropdown {
    constructor(selectElement) {
      this.selectElement = selectElement;
      this.dropdown = document.createElement("div");
      this.dropdown.classList.add("f-dropdown", "selectDropdown");
      this.label = document.createElement("span");
      this.list = document.createElement("ul");
      this.priceLabel = document.getElementById(`${this.selectElement.id}-price`);
  
      // Wrap the select element with our custom dropdown
      this.selectElement.parentNode.insertBefore(this.dropdown, this.selectElement);
      this.dropdown.appendChild(this.selectElement);
      this.dropdown.appendChild(this.label);
      this.dropdown.appendChild(this.list);
  
      this.initOptions();
      this.initEventListeners();
      this.updatePrice(); // Initial price update
      this.updateDisabledState(); // Initial disabled state update
    }
  
    initOptions() {
      Array.from(this.selectElement.options).forEach((option) => {
        const listItem = document.createElement("li");
        const link = document.createElement("a");
        link.dataset.val = option.value;
        link.textContent = option.textContent;
  
        const image = option.dataset.image;
        if (image) {
          const img = document.createElement("img");
          img.src = image;
          link.prepend(img);
        }
  
        if (option.disabled) {
          listItem.classList.add("disabled");
        }
  
        listItem.appendChild(link);
        this.list.appendChild(listItem);
      });
  
      const selectedOption = this.selectElement.options[this.selectElement.selectedIndex];
      if (selectedOption.value !== "None") {
        this.list.querySelector(`li a[data-val="${selectedOption.value}"]`).parentNode.classList.add("active");
        this.dropdown.classList.add("filled");
        this.label.innerHTML = this.list.querySelector("li.active a").innerHTML;
      } else {
        this.label.textContent = this.selectElement.getAttribute("placeholder") || "Select Option";
      }
    }
  
    initEventListeners() {
      this.dropdown.addEventListener("click", (e) => {
        if (this.selectElement.disabled) return;
  
        if (e.target.tagName === "A" && !e.target.parentNode.classList.contains("disabled")) {
          e.preventDefault();
          const isActive = e.target.parentNode.classList.contains("active");
          const label = isActive ? (this.selectElement.getAttribute("placeholder") || "Select Option") : e.target.innerHTML;
  
          Array.from(this.selectElement.options).forEach((option) => {
            option.selected = option.value === e.target.dataset.val;
          });
  
          Array.from(this.list.children).forEach((li) => {
            li.classList.remove("active");
          });
  
          this.dropdown.classList.toggle("filled", !isActive);
          this.label.innerHTML = label;
  
          if (!isActive) {
            e.target.parentNode.classList.add("active");
            this.updatePrice(); // Update price when a new option is selected
          }
  
          this.dropdown.classList.remove("open");
          
          // Trigger change event on the select element
          const event = new Event('change', { bubbles: true });
          this.selectElement.dispatchEvent(event);
        }
      });
  
      this.label.addEventListener("click", () => {
        if (!this.selectElement.disabled) {
          this.dropdown.classList.toggle("open");
        }
      });
  
      document.addEventListener("click", (e) => {
        if (!this.dropdown.contains(e.target)) {
          this.dropdown.classList.remove("open");
        }
      });
  
      // Listen for changes to the disabled attribute
      const observer = new MutationObserver(() => this.updateDisabledState());
      observer.observe(this.selectElement, { attributes: true, attributeFilter: ['disabled'] });
    }
  
    updatePrice() {
      const selectedOption = this.selectElement.options[this.selectElement.selectedIndex];
      const price = selectedOption.getAttribute('price');
      const comparePrice = selectedOption.getAttribute('compare-price');
      if (this.priceLabel) {
        if (comparePrice && comparePrice !== 'None') {
          this.priceLabel.innerHTML = `${price} - <compare style="color:red;font-style: italic;">${comparePrice}</compare>`;
        } else if (price && price !== 'None') {
          this.priceLabel.textContent = price;
        } else {
          this.priceLabel.textContent = '';
        }
      }
    }
  
    updateDisabledState() {
      if (this.selectElement.disabled) {
        this.dropdown.classList.add("disabled");
        this.dropdown.classList.remove("open");
      } else {
        this.dropdown.classList.remove("disabled");
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll("select.f-dropdown").forEach((select) => {
      new MySelectDropdown(select);
    });
  });